import { ForegroundColors, NeutralColors } from "../../constants/colors";
import { GRID_UNIT } from "../../constants/design";
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
var alignmentStyles = {
  left: css(["left:0;transform:translateY(100%);"]),
  center: css(["left:50%;transform:translateY(100%) translateX(-50%);"]),
  right: css(["right:0;transform:translateY(100%);"])
};
export var DropdownContainer = styled.div.withConfig({
  componentId: "sc-9bag0o-0"
})(["position:relative;"]);
export var getDropdownTriggerProps = function getDropdownTriggerProps(props) {
  return {
    'aria-haspopup': 'menu',
    'aria-controls': props.menuId,
    'aria-expanded': props.open
  };
};
export var DropdownTrigger = styled.button.attrs(getDropdownTriggerProps).withConfig({
  componentId: "sc-9bag0o-1"
})(["cursor:pointer;border:none;background-color:transparent;padding:0;margin:0;"]);
DropdownTrigger.propTypes = {
  id: PropTypes.string.isRequired,
  menuId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
};
export var DropdownMenuContainer = styled.div.withConfig({
  componentId: "sc-9bag0o-2"
})(["position:absolute;bottom:-", "px;background-color:", ";color:", ";border-radius:8px;box-shadow:rgba(0,0,0,0.08) 0 2px 4px,rgba(0,0,0,0.06) 0 2px 12px;padding:", "px 0;min-width:150px;max-width:250px;display:", ";", ""], GRID_UNIT, NeutralColors.White, NeutralColors.Ink, GRID_UNIT, function (_ref) {
  var open = _ref.open;
  return open ? 'block' : 'none';
}, function (_ref2) {
  var alignment = _ref2.alignment;
  return alignmentStyles[alignment];
});
export var DropdownSection = styled.div.withConfig({
  componentId: "sc-9bag0o-3"
})(["&:not(:last-child){border-bottom:1px solid rgba(0,0,0,0.07);padding-bottom:", "px;margin-bottom:", "px;}"], GRID_UNIT, GRID_UNIT);
export var DropdownLink = styled.a.attrs(function (_ref3) {
  var href = _ref3.href;
  return {
    as: href ? 'a' : 'button',
    role: 'menuitem'
  };
}).withConfig({
  componentId: "sc-9bag0o-4"
})(["display:flex;align-items:center;padding-left:", "px;padding-right:", "px;min-height:", "px;border:none;background:none;width:100%;&:not(:last-child){margin-bottom:", "px;}color:", ";&:hover,&:focus{background-color:", ";}"], GRID_UNIT * 2, GRID_UNIT * 2, GRID_UNIT * 4, GRID_UNIT / 2, function (_ref4) {
  var destructive = _ref4.destructive;
  return destructive ? ForegroundColors.CriticalDefault : NeutralColors.Ink;
}, NeutralColors.Grey100);
DropdownLink.propTypes = {
  destructive: PropTypes.bool
};
DropdownLink.defaultProps = {
  destructive: false
};